module.exports = [
  {
    url: '/permission/all',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: [
          {
            permission_id: '828763026348834816',
            name: '系统管理',
            code: 'sys:manage',
            route: '',
            type: 0,
            icon: '',
            status: 1,
            remark: '运维角色',
            pid: '0',
            create_user_id: '100',
            create_time: '2024-01-29 22:13:15',
            update_time: '2024-01-29 22:13:15',
            deleted: 0,
          },
          {
            permission_id: '222',
            name: '部门领导',
            code: 'sys:manage',
            route: '',
            type: 0,
            icon: '',
            status: 1,
            remark: '运维角色',
            pid: '828763026348834816',
            create_user_id: '100',
            create_time: '2024-01-29 22:13:15',
            update_time: '2024-01-29 22:13:15',
            deleted: 0,
          },
          {
            permission_id: '333',
            name: '部门领导2',
            code: 'sys:manage',
            route: '',
            type: 0,
            icon: '',
            status: 1,
            remark: '运维角色',
            pid: '828763026348834816',
            create_user_id: '100',
            create_time: '2024-01-29 22:13:15',
            update_time: '2024-01-29 22:13:15',
            deleted: 0,
          },
          {
            permission_id: '444',
            name: '工作人员',
            code: 'sys:manage',
            route: '',
            type: 0,
            icon: '',
            status: 1,
            remark: '运维角色',
            pid: '333',
            create_user_id: '100',
            create_time: '2024-01-29 22:13:15',
            update_time: '2024-01-29 22:13:15',
            deleted: 0,
          },
        ],
      }
    },
  },
  {
    url: '/permission/get',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: {
          permission_id: '828763026348834816',
          name: '系统管理',
          code: 'sys:manage',
          route: '',
          type: 0,
          icon: '',
          status: 1,
          remark: '运维角色',
          pid: '0',
          create_user_id: '100',
          create_time: '2024-01-29 22:13:15',
          update_time: '2024-01-29 22:13:15',
          deleted: 0,
        },
      }
    },
  },
  {
    url: '/permission/findByRoleId',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: [
          {
            permission_id: '828763026348834816',
            name: '系统管理',
            code: 'sys:manage',
            route: '',
            type: 0,
            icon: '',
            status: 1,
            remark: '运维角色',
            pid: '0',
            create_user_id: '100',
            create_time: '2024-01-29 22:13:15',
            update_time: '2024-01-29 22:13:15',
            deleted: 0,
          },
        ],
      }
    },
  },
  {
    url: '/permission/save',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: '',
      }
    },
  },
  {
    url: '/permission/update',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: '',
      }
    },
  },
  {
    url: '/permission/delete',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: '',
      }
    },
  },
]
